<template>
  <div @click="show = true"
      class="dashboard__table__row cursor-pointer">
    <div class="dashboard__table__column" style="width: 20%;">
      {{ inbox.fromUser?.login }}
    </div>
    <div class="dashboard__table__column" style="width:30%;">
      <div class="dashboard__table__address">
        <span :class="[ !inbox.read ? 'font-bold text-gray-900': 'text-gray-600']">{{ inbox.title }}</span>
      </div>
    </div>
    <div class="dashboard__table__column" style="width: 21%;">
      {{ inbox.docExpertise?.name }}
    </div>
    <div class="dashboard__table__column" style="width: 8.5%;">
      {{ $moment(inbox.createdAt).format('DD.MM.YYYY HH:mm') }}
    </div>
    <div class="dashboard__table__column" style="width: 20.5%;">
      <div class="dashboard__table__status orange__medium">{{ inbox.statusText }}</div>
    </div>

    <div v-if="show" class="request__window opened" v-click-outside="() => show = false">
      <div class="user__panel panel__bordered">
        <div class="user__panel__avatar">
          <img src="@/assets/v2/img/user__avatar.jpg" alt="avatar" class="user__panel__img">
        </div>
        <div class="user__panel__info">
          <div class="user__panel__name">{{ inbox.fromUser?.userInfo?.fullName }}</div>
          <div class="user__panel__subname">{{ inbox.fromUser?.login }}</div>
        </div>
      </div>
      <div class="request__window__title">{{ inbox.title }}</div>
      <div class="request__window__description">{{ inbox.message }}</div>
      <Actions :inbox="inbox"/>
    </div>
  </div>
</template>
<script>
import Actions from "../../../components/applicant/inbox/Actions.vue";
export default {
  props: {
    inbox: Object
  },
  components: {
    Actions
  },
  data() {
    return {
      show: false
    }
  }
}
</script>